import { cn } from '../../lib/utils'

type HtmlTag = 'div' | 'span' | 'p' | keyof HTMLElementTagNameMap

interface SkeletonProps extends React.HTMLAttributes<HTMLElement> {
  as?: HtmlTag
  dark?: boolean
}

function Skeleton({ as: Tag = 'div', className, children, dark = false, ...props }: SkeletonProps) {
  return (
    <Tag
      className={cn('animate-pulse rounded bg-sunken-surface-bg', className, dark && 'bg-sub-surface-bg-inverse')}
      data-testid="skeleton"
      {...props}
    >
      {children}
    </Tag>
  )
}

export { Skeleton }
